import React from 'react';

import SidebarNavItem from './SidebarNavItem';
import { useTranslation } from 'react-i18next';

const SidebarNavItems = props => {
  // eslint-disable-next-line react/prop-types
  const { items = [], isCollapsed = false, isNested = false } = props;
  // const classes = useStyles()
  const { t } = useTranslation();
  return (
    <>
      {items.map((item, index) => (
        <SidebarNavItem
          subMenu={t(item?.subMenu)}
          {...item}
          isCollapsed={isCollapsed}
          isNested={isNested}
          key={index}
        />
      ))}
    </>
  );
};

export default SidebarNavItems;
